import { createSelector } from 'reselect'
import color from 'color'
import * as R from 'ramda'

const bgLightness = 96

export const gradientSelector = createSelector(R.identity, baseColor => {
  // @ts-expect-error color lib has no exported ColorParam type
  const $base = color(baseColor)
  const $saturated = $base.saturate(0.5)
  const $desaturated = $base.desaturate(0.85)

  const $left = $saturated.lightness(bgLightness)
  const $right = $desaturated.lightness(bgLightness)

  return `linear-gradient(120.05deg, ${$left.hex()} -59.86%, ${$right.hex()} 100%)`
})
